import { useSelector } from 'react-redux'
import { formatNumber } from '../../../../../../utility'
import Number from '../../../../../UI/Input/Number'
import props from '../../../../../../redux/props'

type Props = {
  label: string
  value: number
  onChange?: false | ((value: number) => void)
  suffix?: string
  decimal?: boolean
  disabled?: boolean
  originalValue?: number
}

const ValueInput: React.FC<Props> = ({ label, value, onChange, suffix, decimal = false, disabled = false, originalValue = null }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div className="flex gap-5 items-center justify-between">
      <div className="font-light text-md text-nowrap">{label}</div>
      <div className="w-1/2 flex items-center gap-3 justify-end">
        {/* {!onChange && (
          <div className="text-md text-blue">
            {value}
            {suffix}
          </div>
        )}
        {!!onChange && ( */}
        <div className="flex gap-3 items-center w-full">
          {!!originalValue ? (
            <div className="whitespace-nowrap w-1/2 shrink-0">{`${t.survey.analysis.calculation.values.originalValuePrefix}${formatNumber(
              originalValue,
            )}${suffix || ''}`}</div>
          ) : (
            <div className="whitespace-nowrap w-1/2 shrink-0">&nbsp;</div>
          )}
          <Number
            className="w-1/2"
            contentClassName={!onChange || disabled ? ' !border-transparent !opacity-100 !text-right' : ''}
            value={value}
            onChange={!!onChange ? onChange : undefined}
            suffix={suffix}
            decimal={decimal}
            disabled={disabled || !onChange}
            readOnly={!onChange}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  )
}

export default ValueInput
